import type { KycStatus, WizardSessionState } from './types';

/**
 * ¿Tiene sentido seguir repreguntando por el KYC?
 *
 * No alcanza con mirar el estado del KYC. Una sesión pausada por CURP repetido se queda en `WAITING`
 * de forma permanente: la verificación salió bien y lo que falló después fue el alta del cliente, que
 * ya no va a reintentarse sola. Preguntar por ese estado es girar en vacío hasta que el vendedor
 * cierre la pestaña.
 */
export function sigueEsperandoElKyc(
    estadoKyc: KycStatus,
    estadoSesion?: WizardSessionState,
): boolean {
    if (estadoSesion === 'PAUSED_CURP_CONFLICT') return false;
    return estadoKyc === 'WAITING';
}

/** Tope de un intento de MetaMap (KYC, selfie o comprobante), contado desde `attemptStartedAt`. */
export const KYC_ESPERA_MAX_MS = 25 * 60_000;

/**
 * ¿La espera ya pasó de lo razonable?
 *
 * Red de seguridad para todo lo que el silo todavía no sabe explicar. Hoy hay fallas que dejan la
 * sesión intacta —el alta del cliente revienta, el mensaje se recicla al DLQ— y desde la pantalla se
 * ven idénticas a un KYC que sigue corriendo. Sin un tope, el vendedor se queda mirando el mismo
 * spinner hasta que cierra la pestaña.
 *
 * `null` = el cronómetro todavía no arrancó (la pantalla no entró en espera). No hay nada que medir,
 * así que no se agota: mostrar un error ahí sería inventarlo.
 *
 * Cortar de más es caro —obliga a rehacer el KYC entero—, así que el tope es generoso a propósito.
 */
export function laEsperaSeAgoto(msEsperando: number | null): boolean {
    if (msEsperando === null) return false;
    return msEsperando >= KYC_ESPERA_MAX_MS;
}
